define([
    './ModalService',
    'edge/platform/widgets/modal/ModalCtrl',
    './ModalProvider',

    './dataStructures/StackedMap',
    './dataStructures/ModalStack',

    './directives/ModalBackdrop',
    './directives/ModalWindow'
], (ModalService, ModalController, ModalProvider, StackedMap, ModalStack, ModalBackdropDirective, ModalWindowDirective)=> {
    return angular.module('edge.platform.widgets.modal', [])
        .factory('$$stackedMap', StackedMap) //Internal data structure
        .factory('$modalStack', ModalStack)  //Internal data structure
        .provider('$modal', ModalProvider)
        .factory('ModalService', ModalService)
        .controller('ModalController', ModalController)
        .directive('modalBackdrop', ModalBackdropDirective) //A helper directive for the $modal service. It creates a backdrop element.
        .directive('modalWindow', ModalWindowDirective);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/modal/module.js